import { router } from "@inertiajs/vue3";

/**
 * Inertia keeps every page's props in browser history, encrypted with a key held in sessionStorage
 * (INERTIA_ENCRYPT_HISTORY), so Back can redraw a page without asking the server. Discarding the key
 * makes those entries unreadable: Back then has to fetch the page, and a dead session lands on login
 * instead of on the previous user's chats (BUG-1125).
 */

/**
 * Call right before submitting a logout form. Some logouts leave Coach for Auth0 or an SSO logout URL
 * before any Coach page renders again, so the key has to go while we still control the page. Also
 * drops the current entry, so Back from the login page can't land on it (VULN-18).
 */
export function discardBrowserHistory(): void {
    router.clearHistory();
    globalThis.history.replaceState(null, "", globalThis.location.href);
}

function isSignedOutPage(page: { props: Record<string, unknown> }): boolean {
    const userDetails = page.props.user_details as { is_anonymous?: boolean } | undefined;
    return userDetails?.is_anonymous === true;
}

/**
 * Discard the key on every signed-out page. However the session ended -- logout, idle expiry, an expired
 * cookie, a logout in another tab -- the server answers the next visit with a signed-out page, so this
 * one rule covers paths that never reach a logout button or the session-ended dialog.
 */
export function clearHistoryOnSignedOutPages(): void {
    router.on("navigate", (event) => {
        if (isSignedOutPage(event.detail.page)) {
            router.clearHistory();
        }
    });
}
